const MAX_SIZE_2MB = 2_097_152; // 2MB in bytes

export { MAX_SIZE_2MB };
